import React from 'react';
import { cn } from '@/lib/utils';

export const LOADING_RING_REFERENCE_SIZE_PX = 32;
export const LOADING_RING_REFERENCE_STROKE_PX = 3;

export const getLoadingRingStrokeWidth = (diameterPx: number): number =>
  Math.max(
    2,
    Math.round((LOADING_RING_REFERENCE_STROKE_PX / LOADING_RING_REFERENCE_SIZE_PX) * diameterPx),
  );

export const getLoadingRingDiameterForContent = (contentSizePx: number): number => {
  let diameterPx = contentSizePx;

  for (let attempt = 0; attempt < 10; attempt += 1) {
    const strokePx = getLoadingRingStrokeWidth(diameterPx);
    const nextDiameterPx = contentSizePx + 4 * strokePx;

    if (nextDiameterPx === diameterPx) {
      break;
    }

    diameterPx = nextDiameterPx;
  }

  return diameterPx;
};

interface LoadingRingProps {
  diameterPx?: number;
  activeColor?: string;
  trackColor?: string;
  spinDurationMs?: number;
  className?: string;
}

export const LoadingRing: React.FC<LoadingRingProps> = ({
  diameterPx = LOADING_RING_REFERENCE_SIZE_PX,
  activeColor = 'var(--muted-foreground)',
  trackColor = '#e5e7eb',
  spinDurationMs = 800,
  className,
}) => {
  const strokePx = getLoadingRingStrokeWidth(diameterPx);

  return (
    <>
      <style>{`
        @keyframes loading-ring-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div
        className={cn('rounded-full', className)}
        style={{
          width: diameterPx,
          height: diameterPx,
          border: `${strokePx}px solid ${trackColor}`,
          borderTopColor: activeColor,
          animation: `loading-ring-spin ${spinDurationMs}ms linear infinite`,
        }}
        aria-hidden="true"
        data-testid="loading-ring"
        data-stroke-width={strokePx}
      />
    </>
  );
};
